// extracted by mini-css-extract-plugin
export const container = "prevention-module--container--2xp-9";
export const content = "prevention-module--content--19RGZ";
export const img = "prevention-module--img--36ufC";